module.exports = require("./de-AT.d.ts");